module.exports = __webpack_public_path__ + "static/media/skiing.48c3e1d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/skiing.svg
// module id = 397
// module chunks = 7